'use strict';

angular.module('mean.accounting').factory('ReconcileService', ['$resource',
	function ($resource) {
		return $resource('/api/accounting/reconciliation/:docId', {
			docId: '@_id'
		}, {
			update: {
				method: 'PUT'
			}
		});
	}
]);


// WEBPACK FOOTER //
// ./packages/custom/accounting/public/services/reconciliation.js